// Auto-generated manifest for responsive images
export const courseIconManifest: Record<string, any> = {
    "c": {
        "200": "/assets/images/courses/responsive/c-200.webp",
        "300": "/assets/images/courses/responsive/c-300.webp",
        "400": "/assets/images/courses/responsive/c-400.webp",
        "600": "/assets/images/courses/responsive/c-600.webp",
        "placeholder": "data:image/webp;base64,UklGRiwAAABXRUJQVlA4ICAAAABwAQCdASoQAA4ABUB8JYwCdAFAAAD+7qxFJ0goGgAAAA=="
    },
    "html": {
        "200": "/assets/images/courses/responsive/html-200.webp",
        "300": "/assets/images/courses/responsive/html-300.webp",
        "400": "/assets/images/courses/responsive/html-400.webp",
        "600": "/assets/images/courses/responsive/html-600.webp",
        "placeholder": "data:image/webp;base64,UklGRiwAAABXRUJQVlA4ICAAAABwAQCdASoQAA4ACoB8JZwC7AFAAAD+7zX4cmsM5gAAAA=="
    },
    "javascript": {
        "200": "/assets/images/courses/responsive/javascript-200.webp",
        "300": "/assets/images/courses/responsive/javascript-300.webp",
        "400": "/assets/images/courses/responsive/javascript-400.webp",
        "600": "/assets/images/courses/responsive/javascript-600.webp",
        "placeholder": "data:image/webp;base64,UklGRigAAABXRUJQVlA4IBwAAAAwAQCdASoQAA8ADkB8JZwAA3AA/u4fg9asNsAA"
    },
    "python": {
        "200": "/assets/images/courses/responsive/python-200.webp",
        "300": "/assets/images/courses/responsive/python-300.webp",
        "400": "/assets/images/courses/responsive/python-400.webp",
        "600": "/assets/images/courses/responsive/python-600.webp",
        "placeholder": "data:image/webp;base64,UklGRiwAAABXRUJQVlA4ICAAAABQAQCdASoQAA4ACoB8JQBOgCgAAP7tYrHMQmrA2d1EAA=="
    },
};
